import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'En 3 noches ya dormía distinto. En una semana pensaba más claro.',
    text: 'Probé de todo para la niebla mental. Esto fue lo primero que realmente cambió algo. Puedo concentrarme de nuevo.',
    author: 'Clara D., 58 años — Córdoba'
  }, {
    quote: 'El dolor en las rodillas bajó un 80% — sin tomar nada.',
    text: 'La receta era tan simple. Tenía todos los ingredientes en casa. Sin ibuprofeno todas las mañanas — algo que no lograba desde hace años.',
    author: 'Jorge R., 65 años — Buenos Aires'
  }, {
    quote: 'Pensé que era la edad. Resulta que mi cuerpo solo necesitaba el apoyo correcto.',
    text: 'Volví a tener energía para hacer cosas que había dejado de hacer hace años. Sin pastillas, sin dietas raras, sin gastar una fortuna.',
    author: 'Vanesa M., 63 años — Mendoza'
  }, {
    quote: 'Después de 7 años con medicación para el reflujo, lo manejo con una sola receta.',
    text: 'Limón, jengibre y miel. Funciona mejor que cualquier otra cosa que haya probado. Mi médico quedó sorprendido con mis análisis.',
    author: 'Eduardo W., 60 años — Rosario'
  }];
  return <section className="py-20 bg-white" data-id="element-273">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274">
        <div className="text-center mb-16" data-id="element-275">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-marron mb-6" data-id="element-276">
            Personas Reales. Resultados Reales.
          </h2>
          <p className="text-lg text-marron-light max-w-2xl mx-auto" data-id="element-277">
            Más de 50.000 personas en todo el mundo ya están usando estas
            fórmulas. Esto es lo que están viviendo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-278">
          {testimonials.map((t, i) => <div key={i} className="bg-crema p-8 rounded-2xl border border-crema-darker relative" data-id="element-279">
              <Quote className="absolute top-6 left-6 w-10 h-10 text-oliva/20 transform -scale-x-100" data-id="element-280" />
              <div className="relative z-10 pt-4" data-id="element-281">
                <h3 className="text-xl font-bold text-marron mb-4 leading-tight" data-id="element-282">
                  "{t.quote}"
                </h3>
                <p className="text-marron-light italic mb-6" data-id="element-283">{t.text}</p>
                <div className="flex items-center justify-between border-t border-marron/10 pt-4" data-id="element-284">
                  <div className="flex text-mostaza" data-id="element-285">
                    {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-current" data-id="element-286" />)}
                  </div>
                  <span className="font-bold text-oliva text-sm" data-id="element-287">
                    {t.author}
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}